import React from "react";

export default class NotFound extends React.Component {
    render() {
        return (
            <h1>Page Not Found</h1>
        );
    }
}
